/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import './FieldSwitch.scss';

const ns = 'field-switch';

const FieldSwitch = ({
  name,
  label,
  onChange,
  checked,
  onClick,
  className,
  disabled
}) => {
  const classProps = cn(ns, className);
  return (
    <div
      className={classProps}
      onKeyUp={e => {
        if (e.key === 'Enter') {
          const checkBoxInput = document.getElementById(name);
          checkBoxInput.click();
        }
      }}
      tabIndex={0}
    >
      {label && (
        <label className={`${ns}__switch-label`} htmlFor={name}>
          {label}
        </label>
      )}
      <label className={`${ns}__switch`}>
        <input
          disabled={disabled}
          id={name}
          type="checkbox"
          onChange={e => onChange(e)}
          checked={checked}
          onClick={e => onClick(e)}
          tabIndex={-1}
        />
        <span className={`${ns}__switch--slider round`} />
      </label>
    </div>
  );
};

FieldSwitch.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

FieldSwitch.defaultProps = {
  onClick: () => {},
  disabled: false
};

export default FieldSwitch;



// WEBPACK FOOTER //
// ./src/components/atoms/FieldSwitch/FieldSwitch.js